module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gz7wA"))).then(() => parcelRequire('fThBo'));